<div class="col-12 px-0 m-15" *ngIf="checkoutConfig && checkoutConfig.displaySearchAddressSection">
    <app-search-address [countries]="countries" [countryCode]="countryCode" (rebindAddress)="rebindAddressInfo($event)" (getSearchAddressOptions)="getSearchAddressOptionsInfo($event)" [isFromFboProfile]="isFromFboProfile"></app-search-address>
</div>
<div *ngIf="displayAddressBlock">
    <div class="template3 schema-form--inline" [class.hideValidation]="validationMessageInitialHide" *ngIf="jsonFormObject">
        <json-schema-form [widgets]="customWidgets" [framework]="selectedFrameWork" [form]="jsonFormObject" [options]="jsonFormOptions"
            (valueChanges)="changeInputValue($event)" (onChanges)="onChanges($event)" (isValid)="liveFormDataIsValid($event)"
            (onSubmit)="saveAddress($event,true)" (btnClick)="verifyButtonSubmit($event)">
        </json-schema-form>
    </div>
</div>

<!-- addresss model starts- it will load other than mobile all devices -->
<div class="template3">
    <modal #addressModal id="address-verification--modal">
        <modal-header>
            <div class="message-modal-header py-2" *ngIf="addressVerificationForm && !errorCodesLength">
                <h3 class="title">{{'checkout.Edit Your Address' | translate | translateKey}}</h3>
            </div>
            <div class="message-modal-header py-2" *ngIf="addressVerificationForm && errorCodesLength">
                <h3 class="title margin-top-0">{{'checkout.Complete Your Address' | translate | translateKey}}</h3>
                <div class="title-info">{{'checkout.The address you entered is missing valid apartment, suite,
                    floor or building number details. Please check your address below.' | translate |
                    translateKey}}
                </div>
                <div class="row pt-3">
                    <ul>
                        <li class="text-red" *ngFor="let err of errorCodes">{{err.shortDescription}}</li>
                      </ul>
                </div>
            </div>
            <div class="message-modal-header py-2" *ngIf="!addressVerificationForm">
                <div class="title margin-top-0">{{'checkout.Select the Correct Address' | translate | translateKey}}</div>
                <div class="title-info">{{'checkout.According to UPS, the address you entered may be incorrect or
                    missing some details. Please verify your address and choose from one of the options below, or
                    proceed with the address as entered.' | translate | translateKey}}</div>
            </div>
        </modal-header>
        <modal-content>
            <div *ngIf="!addressVerificationForm">
                <div class="row suggest-address">
                    <div class="col-12 col-md-6">
                        <div>
                            <h3 class="title">{{'checkout.You Entered' | translate | translateKey}}</h3>
                        </div>
                        <div tabindex="0" class="address-selection" *ngIf="originalAddress">
                            <label tabindex="0" class="label-radio" attr.aria-label="{{'checkout.entered address' | translate | translateKey}}">
                                <input role="radio" tabindex="-1" type="radio" (click)="setAddressType('originalAddress')"
                                    name="selectedAddressType" value="originalAddress">
                                <span class="label-text"></span>
                                <div class="address-selection__address">
                                    <div>{{originalAddress.addressLine1}}</div>
                                    <div>{{originalAddress.addressLine2}}</div>
                                    <div class="">{{originalAddress.city}}, <span *ngIf="checkoutConfig && checkoutConfig.showStateCode">{{originalAddress.state}}</span>
                                        {{originalAddress.postalCode}}
                                    </div>
                                    <div class="">{{originalAddress.countryCode | uppercase}}</div>
                                </div>
                            </label>
                        </div>
                        <div class="text-center mt-2">
                            <a tabindex="0" class="underline" (click)="editAddress(originalAddress)" attr.aria-label="{{'checkout.Edit' | translate | translateKey}}"
                                (keyup.enter)="editAddress(originalAddress)">
                                <span class="">{{'checkout.Edit' | translate | translateKey}} </span>
                                <i class="fa fa-pencil"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mt-3 mt-md-0">
                        <div class="">
                            <h3 class="title">{{'checkout.Suggested Address' | translate | translateKey}}</h3>
                        </div>
                        <div tabindex="0" class="address-selection" *ngIf="suggestedAddress">
                            <label tabindex="0" class="label-radio" attr.aria-label="{{'checkout.entered address' | translate | translateKey}}">
                                <input role="radio" tabindex="-1" checked type="radio" (click)="setAddressType('suggestedAddress')"
                                    name="selectedAddressType" value="suggestedAddress">
                                <span class="label-text"></span>
                                <div class="address-selection__address">
                                    <div>{{suggestedAddress.addressLine1}}</div>
                                    <div>{{suggestedAddress.addressLine2}}</div>
                                    <div class="">{{suggestedAddress.city}}, <span *ngIf="checkoutConfig && checkoutConfig.showStateCode">{{suggestedAddress.state}}</span>
                                        {{suggestedAddress.postalCode}}
                                    </div>
                                    <div class="">{{suggestedAddress.country| uppercase}}</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div class="col-12 my-3 text-center">
                        <button role="button" attr.aria-label="{{'common.Continue' | translate | translateKey}}"
                            tabindex="0" type="button" (keyup.enter)="selectAddress(null)" (click)="selectAddress(null)" class="btn blue-button mt-10">{{'common.Next'
                            | translate | translateKey}}</button>
                    </div>
                </div>
            </div>
            <div class="row modal-body mt-3" *ngIf="addressVerificationForm&&jsonFormObject">
                <json-schema-form class="form-width" [widgets]="customWidgets" [framework]="selectedFrameWork" [form]="jsonFormObject"
                    [options]="jsonFormOptions" (onChanges)="onChanges($event)" (onSubmit)="saveAddress($event,true)"
                    (isValid)="liveFormDataIsValid($event)" (valueChanges)="changeInputValue($event)" (btnClick)="verifyButtonSubmit($event)">
                </json-schema-form>
            </div>
        </modal-content>
    </modal>
</div>
<!-- addresss model ends -->


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/address/address.component.html